
// import React, { useState } from "react";
// import BannerImage from "../assets/images/LoginImage.png";
// // import Logo from "../assets/images/Naach Logo _Final_Curved-03.png";
// // import logoAnimation from "../assets/animation/logoAnimation.webm";
// import { MdOutlineEmail } from "react-icons/md";
// import { FaEye, FaEyeSlash, FaApple , FaFacebook } from "react-icons/fa";
// import { FcGoogle } from "react-icons/fc";

// import axios from "axios";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// // import { jwtDecode } from "jwt-decode";

// // import { useDispatch } from "react-redux";
// // import { setUserDetails } from "../store/userSlice";
// import SummaryApi from "../common/SummaryApi";

// const Login = () => {
//   // const dispatch = useDispatch();
//   const [formData, setFormData] = useState({ email: "", password: "" });
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const navigate = useNavigate();


//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });

//     if (errors[name]) {
//       setErrors({ ...errors, [name]: null });
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.email) newErrors.email = "Email is required";
//     else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "Please enter a valid email";
//     if (!formData.password) newErrors.password = "Password is required";
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;
//     setIsSubmitting(true);

//     try {
//       const { data } = await axios.post(SummaryApi.signIn.url, formData);
//       // const decoded = jwtDecode(data.token);
//       // const userId = decoded.id;

//       localStorage.setItem("token", data.token);

//       // const userRes = await axios.get(SummaryApi.getUserById.url(userId), {
//       //   headers: { Authorization: `Bearer ${data.token}` },
//       // });

//       // dispatch(setUserDetails(userRes.data.data));
//       toast.success("Login successful!");
//       navigate("/");

//     } catch (error) {
//       console.error("Login failed:", error);
//       toast.error(error?.response?.data?.message || "Login failed. Please check your credentials.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };


//   return (




//     <div className="w-full h-screen flex">

//       {/* Left Image Section (only visible on large screens) */}
// <div className="hidden lg:block w-3/5 h-full">
//   <img
//     src={BannerImage}
//     alt="Rtex Banner"
//     className="object-fill"
//   />
// </div>


//       {/* Right Login Section */}
//       <div className="w-full lg:w-2/5 h-full flex items-center justify-center bg-white">
//         <div className="p-6 w-full flex flex-col justify-center">
//           {/* Header */}
//           <div className="flex justify-center mb-8">
//             <h2 className="text-3xl font-bold text-gray-800">Login into your account</h2>
//           </div>

//           {/* Form */}
//           <form onSubmit={handleSubmit} className="w-3/4 mx-auto">
//             {/* Email Field */}
//       {/* EMAIL */}
//       <div className="space-y-2 mb-5">
//         <label className="text-sm text-gray-600">
//           Email Address
//         </label>

//         <div className="relative">
//           <input
//             type="email"
//             name="email"
//             value={formData.email}
//             onChange={handleChange}
//             placeholder="alex@email.com"
//             className="w-full px-4 py-2 pr-12 bg-gray-100 rounded-md focus:outline-none"
//           />

//           <div className="absolute top-0 right-0 h-full w-10 flex items-center justify-center bg-[#007BFF] rounded-r-md">
//             <MdOutlineEmail className="text-white text-lg" />
//           </div>
//         </div>
//       </div>

//       {/* PASSWORD */}
//       <div className="space-y-2 mb-2">
//         <label className="text-sm text-gray-600">
//           Password
//         </label>

//         <div className="relative">
//           <input
//             type={showPassword ? "text" : "password"}
//             name="password"
//             value={formData.password}
//             onChange={handleChange}
//             placeholder="Enter your password"
//             className="w-full px-4 py-2 pr-12 bg-gray-100 rounded-md focus:outline-none"
//           />

//           <div className="absolute top-0 right-0 h-full w-10 flex items-center justify-center bg-[#007BFF] rounded-r-md">
//             <button
//               type="button"
//               className="text-white"
//               onClick={() => setShowPassword(!showPassword)}
//             >
//               {showPassword ? <FaEye /> : <FaEyeSlash />}
//             </button>
//           </div>
//         </div>
//       </div>
//       {/* FORGOT PASSWORD */}
//       <div className="text-right mb-6">
//         <a href="/forgot-password" className="text-sm text-[#007BFF] hover:underline">
//           Forgot Password?
//         </a>
//       </div>
//             {/* Login Button */}
//       <button
//         type="submit"
//         disabled={isSubmitting}
//         className="w-full bg-[#007BFF] text-white py-2.5 rounded-md font-semibold shadow-md hover:bg-blue-600 transition"
//       >
//         {isSubmitting ? "Logging in..." : "Login Now"}
//       </button>

//       {/* OR SEPARATOR */}
//       <div className="flex items-center my-6">
//         <div className="flex-1 border-t border-gray-300"></div>
//         <span className="px-2 text-gray-400 text-sm">OR</span>
//         <div className="flex-1 border-t border-gray-300"></div>
//       </div>

//       {/* SIGNUP BUTTON */}
//       <button
//         type="button"
//         className="w-full border border-[#007BFF] text-[#007BFF] py-2.5 rounded-md font-semibold hover:bg-blue-50 transition"
//       >
//         Signup Now
//       </button>
//             {/* Social Login Buttons */}
//       <div className="flex justify-center space-x-6 mt-6">
//         <button className="text-blue-600 text-3xl">
//           <FaFacebook  />
//         </button>

//         <button className="text-black text-3xl">
//           <FaApple />
//         </button>

//         <button className="text-red-500 text-3xl">
//           <FcGoogle  />
//         </button>
//       </div>


//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

// import React, { useState } from "react";
// import BannerImage from "../assets/images/LoginImage.png";
// import { MdOutlineEmail } from "react-icons/md";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { FcGoogle } from "react-icons/fc";
// import axios from "axios";
// import { toast } from "react-hot-toast";
// import { useNavigate, useLocation } from "react-router-dom";
// import SummaryApi from "../common/SummaryApi";
// import { mergeGuestCart } from "../helpers/cartHelper";
// import { useCart } from "../context/CartContext";
// import { useDispatch } from "react-redux";
// import { setUserDetails } from "../store/userSlice";
// import { useGoogleLogin } from "@react-oauth/google";
// import FacebookLogin from "@greatsumini/react-facebook-login";
// import { FaFacebook } from "react-icons/fa6";


// // import { jwtDecode } from 'jwt-decode';


// const Login = () => {
//   const dispatch = useDispatch();
//   const [formData, setFormData] = useState({ email: "", password: "" });
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const redirectTo = location.state?.redirectTo || "/";
//   // const detected = localStorage.getItem("selected_address");  
//   const { refreshCart } = useCart();
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });

//     if (errors[name]) {
//       setErrors({ ...errors, [name]: null });
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.email) newErrors.email = "Email is required";
//     else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "Please enter a valid email";
//     if (!formData.password) newErrors.password = "Password is required";
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;
//     setIsSubmitting(true);

//     try {
//       const { data } = await axios.post(SummaryApi.signIn.url, formData);
//       localStorage.setItem("token", data.token);
//       // const decoded = jwtDecode(data.token);

//       const userRes = await axios.get(SummaryApi.getProfile.url, {
//         headers: { Authorization: `Bearer ${data.token}` },
//       });

//       dispatch(setUserDetails(userRes?.data?.data));
//       //  Merge the guest cart
//       await mergeGuestCart(data.token);
//       // 🔥 refresh header count
//       refreshCart();
//       //     if (detected) {
//       // const addr = JSON.parse(detected);

//       //   if (addr.isDetected) {
//       //     axios(SummaryApi.saveDetectedAddress, addr);
//       //   }
//       // }
//       toast.success("Login successful!");
//       navigate(redirectTo, { replace: true });

//     } catch (error) {
//       console.error("Login failed:", error);
//       toast.error(error?.response?.data?.message || "Login failed. Please check your credentials.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };
  
//   const googleLogin = useGoogleLogin({
//   onSuccess: async (tokenResponse) => {
//     try {
//       const res = await axios.post(
//         SummaryApi.googleLogin.url,
//         { accessToken: tokenResponse.access_token }
//       );

//       localStorage.setItem("token", res.data.token);

//       const userRes = await axios.get(SummaryApi.getProfile.url, {
//         headers: {
//           Authorization: `Bearer ${res.data.token}`,
//         },
//       });

//       dispatch(setUserDetails(userRes.data.data));

//       await mergeGuestCart(res.data.token);
//       refreshCart();

//       toast.success("Google login successful!");
//       navigate(redirectTo, { replace: true });

//     } catch (err) {
//       toast.error("Google login failed");
//     }
//   },
//   onError: () => {
//     toast.error("Google Login Failed");
//   },
// });


//   return (
//     <div className="">
//       {/* Main Content with 5:3 ratio */}
//       <div className="flex-1 flex flex-col lg:flex-row">
//         {/* Image Section - 5 parts */}
//         <div className="lg:w-1/2 hidden lg:flex">
//           <img
//             src={BannerImage}
//             alt="Rtex Banner"
//             className="object-fill w-full h-[813px] 2xl:h-[870px]"
//           />
//         </div>

//         {/* Login Section - 3 parts */}
//         <div className="lg:w-1/2 flex items-center justify-center bg-white">
//           <div className="w-full max-w-md p-8">
//             {/* Header */}
//             <div className="flex justify-center mb-8">
//               <h2 className="text-3xl font-bold text-gray-800">Login into your account</h2>
//             </div>

//             {/* Form */}
//             <form onSubmit={handleSubmit} className="w-full">
//               {/* Email Field */}
//               <div className="space-y-2 mb-5">
//                 <label className="text-sm text-gray-600">Email Address</label>
//                 <div className="relative">
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     placeholder="alex@email.com"
//                     className="w-full px-4 py-2 pr-12 border bg-gray-100 rounded-md focus:outline-none"
//                   />
//                   <div className="absolute top-0 right-0 h-full w-10 flex items-center justify-center bg-[#007BFF] rounded-md">
//                     <MdOutlineEmail className="text-white text-lg" />
//                   </div>
//                 </div>
//               </div>

//               {/* Password Field */}
//               <div className="space-y-2 mb-2">
//                 <label className="text-sm text-gray-600">Password</label>
//                 <div className="relative">
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     name="password"
//                     value={formData.password}
//                     onChange={handleChange}
//                     placeholder="Enter your password"
//                     className="w-full px-4 py-2 pr-12 border bg-gray-100 rounded-md focus:outline-none"
//                   />
//                   <div className="absolute top-0 right-0 h-full w-10 flex items-center justify-center bg-[#007BFF] rounded-md">
//                     <button
//                       type="button"
//                       className="text-white"
//                       onClick={() => setShowPassword(!showPassword)}
//                     >
//                       {showPassword ? <FaEye /> : <FaEyeSlash />}
//                     </button>
//                   </div>
//                 </div>
//               </div>

//               {/* Forgot Password */}
//               <div className="text-right mb-6">
//                 <a href="/forgot-password" className="text-sm text-[#007BFF] hover:underline">
//                   Forgot Password?
//                 </a>
//               </div>

//               {/* Login Button */}
//               <button
//                 type="submit"
//                 disabled={isSubmitting}
//                 className="w-full bg-[#007BFF] text-white py-2.5 rounded-md font-semibold shadow-md hover:bg-blue-600 transition"
//               >
//                 {isSubmitting ? "Logging in..." : "Login Now"}
//               </button>

//               {/* OR Separator */}
//               <div className="flex items-center my-6">
//                 <div className="flex-1 border-t border-gray-300"></div>
//                 <span className="px-2 text-gray-400 text-sm">OR</span>
//                 <div className="flex-1 border-t border-gray-300"></div>
//               </div>

//               {/* Signup Button */}
//               <button
//                 type="button"
//                 className="w-full border border-[#007BFF] text-[#007BFF] py-2.5 rounded-md font-semibold hover:bg-blue-50 transition"
//                 onClick={() => navigate("/sign-up")}
//               >
//                 Signup Now
//               </button>

//               {/* Social Login Buttons */}
//               <div className="flex justify-center space-x-3">
//               <div className="flex justify-center mt-6">
//               <FacebookLogin
//                 appId={process.env.REACT_APP_FACEBOOK_APP_ID}
//                 onSuccess={async (response) => {
//                   try {
//                     const res = await axios.post(
//                       SummaryApi.facebookLogin.url,
//                       { accessToken: response.accessToken }
//                     );

//                     localStorage.setItem("token", res.data.token);

//                     const userRes = await axios.get(SummaryApi.getProfile.url, {
//                       headers: {
//                         Authorization: `Bearer ${res.data.token}`,
//                       },
//                     });

//                     dispatch(setUserDetails(userRes.data.data));

//                     await mergeGuestCart(res.data.token);
//                     refreshCart();

//                     toast.success("Facebook login successful!");
//                     navigate(redirectTo, { replace: true });

//                   } catch (err) {
//                     toast.error("Facebook login failed");
//                   }
//                 }}
//                 onFail={(err) => {
//                   console.log("FB ERROR:", err);
//                   toast.error("Facebook Login Failed");
//                 }}
//                 render={({ onClick }) => (
//                   <button
//                     type="button"
//                     onClick={onClick}
//                     className="w-12 h-12 flex items-center justify-center
//                               rounded-full"
//                   >
//                     <FaFacebook className="text-[#0163E0] rounded-full text-3xl md:text-4xl" />
//                   </button>
//                 )}
//               />
//               </div>
//                 {/* <button type="button" className="text-black text-3xl hover:opacity-80 transition">
//                   <FaApple />
//                 </button>  */}
//               <div className="flex justify-center mt-6">
//                 <button
//                   type="button"
//                   onClick={() => googleLogin()}
//                   className="w-12 h-12 flex items-center justify-center
//                             rounded-full"
//                 >
//                   <FcGoogle className="text-3xl md:text-4xl" />
//                 </button>
//               </div>

//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useState } from "react";
import BannerImage from "../assets/images/LoginImage.png";
import { MdOutlineEmail } from "react-icons/md";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import axios from "axios"; // You can replace this with your 'api' instance if preferred
import { toast } from "react-hot-toast";
import { useNavigate, useLocation } from "react-router-dom";
import SummaryApi from "../common/SummaryApi";
import { mergeGuestCart } from "../helpers/cartHelper";
import { useCart } from "../context/CartContext";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../store/userSlice";
import { useGoogleLogin } from "@react-oauth/google";
import FacebookLogin from "@greatsumini/react-facebook-login";
import { FaFacebook } from "react-icons/fa6";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { refreshCart } = useCart();
  
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const redirectTo = location.state?.redirectTo || "/";

  // ✅ 1. CENTRALIZED LOGIN SUCCESS HANDLER
  // This removes code duplication from Email, Google, and Facebook handlers
  const handleLoginSuccess = async (token, providerName = "Login") => {
    try {
      // 1. Store Token
      localStorage.setItem("token", token);

      // 2. Fetch User Profile
      const userRes = await axios.get(SummaryApi.getProfile.url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // 3. Update Redux
      dispatch(setUserDetails(userRes?.data?.data));

      // 4. Merge & Refresh Cart
      await mergeGuestCart(token);
      refreshCart();

      // 5. Notify & Redirect
      toast.success(`${providerName} successful!`);
      navigate(redirectTo, { replace: true });

    } catch (error) {
      console.error(`Error during ${providerName} post-processing:`, error);
      toast.error(`Failed to load user profile after ${providerName}.`);
      // Optional: Logout if profile fetch fails
      // localStorage.removeItem("token");
    }
  };

  /* --- FORM HANDLERS --- */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: null });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Please enter a valid email";
    if (!formData.password) newErrors.password = "Password is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* --- EMAIL LOGIN --- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsSubmitting(true);

    try {
      const { data } = await axios.post(SummaryApi.signIn.url, formData);
      // Use the helper
      await handleLoginSuccess(data.token, "Login");
    } catch (error) {
      console.error("Login failed:", error);
      toast.error(error?.response?.data?.message || "Login failed.");
    } finally {
      setIsSubmitting(false);
    }
  };

  /* --- GOOGLE LOGIN --- */
  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await axios.post(SummaryApi.googleLogin.url, {
          accessToken: tokenResponse.access_token,
        });
        // Use the helper
        await handleLoginSuccess(res.data.token, "Google Login");
      } catch (err) {
        console.error("Google API Error:", err);
        toast.error("Google login failed at server.");
      }
    },
    onError: () => {
      toast.error("Google Login Failed");
    },
  });

  return (
    <div className="">
      <div className="flex-1 flex flex-col lg:flex-row">
        {/* Image Section */}
        <div className="lg:w-1/2 hidden lg:flex">
          <img
            src={BannerImage}
            alt="Rtex Banner"
            className="object-fill w-full h-[813px] 2xl:h-[870px]"
          />
        </div>

        {/* Login Section */}
        <div className="lg:w-1/2 flex items-center justify-center bg-white">
          <div className="w-full max-w-md p-8">
            <div className="flex justify-center mb-8">
              <h2 className="text-3xl font-bold text-gray-800">
                Login into your account
              </h2>
            </div>

            <form onSubmit={handleSubmit} className="w-full">
              {/* Email */}
              <div className="space-y-2 mb-5">
                <label className="text-sm text-gray-600">Email Address</label>
                <div className="relative">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="alex@email.com"
                    className="w-full px-4 py-2 pr-12 border bg-gray-100 rounded-md focus:outline-none"
                  />
                  <div className="absolute top-0 right-0 h-full w-10 flex items-center justify-center bg-[#007BFF] rounded-md">
                    <MdOutlineEmail className="text-white text-lg" />
                  </div>
                </div>
                {errors.email && <p className="text-red-500 text-xs">{errors.email}</p>}
              </div>

              {/* Password */}
              <div className="space-y-2 mb-2">
                <label className="text-sm text-gray-600">Password</label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    className="w-full px-4 py-2 pr-12 border bg-gray-100 rounded-md focus:outline-none"
                  />
                  <div className="absolute top-0 right-0 h-full w-10 flex items-center justify-center bg-[#007BFF] rounded-md">
                    <button
                      type="button"
                      className="text-white"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </button>
                  </div>
                </div>
                {errors.password && <p className="text-red-500 text-xs">{errors.password}</p>}
              </div>

              <div className="text-right mb-6">
                <a href="/forgot-password" className="text-sm text-[#007BFF] hover:underline">
                  Forgot Password?
                </a>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#007BFF] text-white py-2.5 rounded-md font-semibold shadow-md hover:bg-blue-600 transition disabled:opacity-70"
              >
                {isSubmitting ? "Logging in..." : "Login Now"}
              </button>

              {/* OR Separator */}
              <div className="flex items-center my-6">
                <div className="flex-1 border-t border-gray-300"></div>
                <span className="px-2 text-gray-400 text-sm">OR</span>
                <div className="flex-1 border-t border-gray-300"></div>
              </div>

              <button
                type="button"
                className="w-full border border-[#007BFF] text-[#007BFF] py-2.5 rounded-md font-semibold hover:bg-blue-50 transition"
                onClick={() => navigate("/sign-up")}
              >
                Signup Now
              </button>

              {/* ✅ 2. FIXED SOCIAL BUTTON LAYOUT */}
              <div className="flex justify-center space-x-6 mt-6">
                {/* Facebook */}
                <FacebookLogin
                  appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                  onSuccess={async (response) => {
                    try {
                      const res = await axios.post(
                        SummaryApi.facebookLogin.url,
                        { accessToken: response.accessToken }
                      );
                      // Use the helper
                      await handleLoginSuccess(res.data.token, "Facebook Login");
                    } catch (err) {
                      console.error("Facebook API Error:", err);
                      toast.error("Facebook login failed at server.");
                    }
                  }}
                  onFail={(err) => {
                    console.log("FB Login Window Error:", err);
                    toast.error("Facebook Login Failed");
                  }}
                  render={({ onClick }) => (
                    <button
                      type="button"
                      onClick={onClick}
                      className="w-12 h-12 flex items-center justify-center rounded-full hover:scale-105 transition-transform"
                    >
                      <FaFacebook className="text-[#0163E0] text-4xl" />
                    </button>
                  )}
                />

                {/* Google */}
                <button
                  type="button"
                  onClick={() => googleLogin()}
                  className="w-12 h-12 flex items-center justify-center rounded-full hover:scale-105 transition-transform"
                >
                  <FcGoogle className="text-4xl" />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;